<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default
  {
    mounted() { },
    methods: {},
  };
</script>
<style lang="less">
// 解决ios系统下拉列表需要点击两下的bug
.el-scrollbar__bar {
  opacity: 1 !important;
}

#app {
  min-height: 100vh;
}
</style>
